<template>
    <div>
        <span>{{$baseFilePath}}</span>
        <p>{{$axios.defaults.baseURL}}</p>
        <p>Git Commit Frontend: {{ hash }}</p>
    </div>
</template>

<script>
export default {
    name: 'Actuator',
    data() {
        return {
            hash: process.env.VUE_APP_GIT_HASH
        }
    }, 
}
</script>
